import React, { useState, useEffect } from "react";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cookie from "js-cookie";
import httpService from "../../../services/httpServices/httpServices";
import helperSpinner from "../../../helpers/spinner";
import helperNumber from "../../../helpers/numbers";
import Pagination from "../../partials/content/Pagination";
import SelectDropDown from "../../partials/content/SelectDropDown";
import actionCookie from "../../../helpers/action-cookie";

function ListPublisher({ categoryUser }) {
  const renderTooltip = (props) => (
    <Tooltip {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>به زودی</span>
    </Tooltip>
  );

  const [categoriesSitePublisher, setCategoriesSitePublisher] = useState([]);
  const [sitesPublisher, setSitesPublisher] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [siteNameSearchFilter, setSiteNameSearchFilter] = useState();
  const [countPage, setCountPage] = useState(1);
  const [categoryNameSearchFilter, setCategoryNameSearchFilter] = useState();
  const [isCheckPreviousSearchInput, setIsCheckPreviousSearchInput] =
    useState(false);

  useEffect(() => {
    if (categoriesSitePublisher.length > 0) {
      return;
    }
    getCategoriesSitesPublisher();
    checkPreviousSearchInput();
  }, []);

  useEffect(() => {
    if (!isCheckPreviousSearchInput) {
      return;
    }
    getSitesPublisher();
  }, [
    currentPage,
    siteNameSearchFilter,
    categoryNameSearchFilter,
    isCheckPreviousSearchInput,
  ]);

  const checkPreviousSearchInput = () => {
    const previousSearchInputPage = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_PAGE
    );
    const previousSiteNameSearch = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH
    );
    const previousCategoryNameSearchFilter = cookie.get(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );

    if (previousSearchInputPage) {
      setCurrentPage(previousSearchInputPage);
    }

    if (previousSiteNameSearch != undefined) {
      setSiteNameSearchFilter(previousSiteNameSearch);
      setInputSearchSitePublisher(previousSiteNameSearch);
    }

    if (previousCategoryNameSearchFilter) {
      setCategoryNameSearchFilter(decodeURI(previousCategoryNameSearchFilter));
    }

    removeCookiePreviousSearchInput();
    setIsCheckPreviousSearchInput(true);
  };

  const setInputSearchSitePublisher = (value = "") => {
    document.querySelector("#site").value = value;
  };

  const removeCookiePreviousSearchInput = () => {
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_PAGE);
    cookie.remove(actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH);
    cookie.remove(
      actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER
    );
  };

  const setSearchInputOnCookie = () => {
    if (currentPage) {
      cookie.set(actionCookie.GROUP_SITE_PUBLISHER_PAGE, currentPage);
    }
    if (siteNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_SITE_NAME_SEARCH,
        siteNameSearchFilter
      );
    }
    if (categoryNameSearchFilter) {
      cookie.set(
        actionCookie.GROUP_SITE_PUBLISHER_CATEGORY_NAME_SEARCH_FILTER,
        encodeURIComponent(categoryNameSearchFilter)
      );
    }
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (siteNameSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&site=${siteNameSearchFilter}`;
    }
    if (categoryNameSearchFilter) {
      if (categoryNameSearchFilter != "همه دسته ها") {
        searchFilterQuery = `${searchFilterQuery}&category=${categoryNameSearchFilter}`;
      }
    }

    return searchFilterQuery;
  };

  const getCategoriesSitesPublisher = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const categories = await sendRequestGetCategoryAllPublisher();
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!categories) {
      return;
    }
    setCategoriesSitePublisher(categories);
  };

  const getSitesPublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const sitesPublisher = await sendRequestSitesPublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!sitesPublisher) {
      return;
    }

    setSitesPublisher(sitesPublisher.data);
    setCountPage(sitesPublisher.total_page);
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateBodyTable = (sitesPublisher) => {
    return sitesPublisher.map((sitePublisher, index) => {
      return (
        <tr key={index}>
          <td>{helperNumber.toPersianNum(index + 1)}</td>
          <td>
            <a href={sitePublisher.url} target="_blank">
              {sitePublisher.url}
            </a>
          </td>
          <td>{sitePublisher.categories.join(" - ")}</td>
          <td>
            <div className="d-flex justify-content-around">
              <span>
                <i className="fa fa-mobile-alt"></i>
              </span>
              <span>
                <i className="fa fa-desktop"></i>
              </span>
            </div>
          </td>
          <td>
            <Link
              onClick={setSearchInputOnCookie}
              to={`/publishers/preview/${sitePublisher.id}/all-page`}
              className="btn btn-info"
            >
              پیش نمایش جایگاه های نمایش تبلیغات
            </Link>
          </td>
        </tr>
      );
    });
  };

  const generateTagSitesPublisher = () => {
    return (
      <>
        <div className="table-responsive pt-3">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>نمایش دهنده</td>
                <td>دسته بندی موضوع</td>
                <td>قابل نمایش در</td>
                <td>نمایش صفحات</td>
              </tr>
            </thead>
            <tbody>
              {sitesPublisher.length > 0 ? (
                generateBodyTable(sitesPublisher)
              ) : (
                <tr>
                  <td
                    colspan="5"
                    className="text-center"
                    style={{ borderBottomRightRadius: "25px" }}
                  >
                    هیچ سایتی با این مشخصات موجود نیست.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
          {countPage > 1 && generatePagination()}
        </div>
      </>
    );
  };

  const sendRequestSitesPublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let sitePublishers;
    try {
      sitePublishers = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/site-publishers?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      return false;
    }

    return sitePublishers.data.data;
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const sendRequestGetCategoryAllPublisher = async () => {
    const headersRequest = getHeaderForRequest();
    let categoryAllPublisher;
    try {
      categoryAllPublisher = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API + "/v1/category-site-publishers",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return categoryAllPublisher.data.data;
  };

  const showSelectCategorySitePublisher = () => {
    let categoriesSitesPublishersForDropDown = categoriesSitePublisher.filter(
      (category) => category.name != categoryUser
    );

    categoriesSitesPublishersForDropDown =
      categoriesSitesPublishersForDropDown.map((category) => {
        return { value: category.id, label: category.name };
      });

    categoriesSitesPublishersForDropDown = [
      { value: 0, label: "همه دسته ها" },
      ...categoriesSitesPublishersForDropDown,
    ];

    let itemSelected;
    if (categoryNameSearchFilter) {
      itemSelected = categoriesSitesPublishersForDropDown.filter(
        (category) => category.label == categoryNameSearchFilter
      );

      if (itemSelected.length > 0) {
        itemSelected = {
          label: itemSelected[0].label,
          value: itemSelected[0].value,
        };
      }
    }

    return (
      <SelectDropDown
        data={categoriesSitesPublishersForDropDown}
        itemSelected={itemSelected}
        setItemHandler={(newItemSelected) => {
          setCategoryNameSearchFilter(newItemSelected.label);
          setCurrentPage(1);
          setSiteNameSearchFilter();
          setInputSearchSitePublisher();
        }}
      />
    );
  };

  return (
    <>
      <div
        className="tab-pane fade show active border border-3 p-2 rounded"
        id="list-publisher"
        role="tabpanel"
        aria-labelledby="list-publisher-tab"
      >
        <div>
          <div className="d-flex  ">
            <div className="container-fluid">
              <div className="row  ">
                <div className="col-12 col-md-7 d-flex">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 col-md-6 ">
                        <div>
                          <label>جستجو آدرس سایت</label>
                        </div>
                        <div>
                          <input
                            onKeyUp={(e) => {
                              setSiteNameSearchFilter(e.target.value);
                              setCurrentPage(1);
                            }}
                            className="form-control"
                            id="site"
                            type="text"
                          />
                        </div>
                      </div>

                      <div className="col-12 col-md-6 d-flex flex-column justify-content-between">
                        <div>
                          <label style={{ fontSize: ".80rem" }}>
                            دسته بندی نمایش دهنده های مرتبط
                          </label>
                        </div>
                        {categoriesSitePublisher.length > 0 &&
                          showSelectCategorySitePublisher()}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-md-5 ">
                  <div className="d-flex flex-row justify-content-around">
                    <div className="d-flex flex-column justify-content-between">
                      <div className="pb-2">بنری</div>
                      <div>
                        <label className="adl-switch">
                          <input disabled type="checkbox" checked={true} />
                          <span className="adl-slider round"></span>
                        </label>
                      </div>
                    </div>
                    <div className="d-flex flex-column justify-content-between ">
                      <div className="pb-2">همسان</div>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <div>
                          <span>
                            <label className="adl-switch">
                              <input disabled type="checkbox" />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </OverlayTrigger>
                    </div>
                    <div className="d-flex flex-column justify-content-between ">
                      <div className="pb-2">پوش</div>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <div>
                          <span>
                            <label className="adl-switch">
                              <input disabled type="checkbox" />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </OverlayTrigger>
                    </div>
                    <div className="d-flex flex-column justify-content-between ">
                      <div className="pb-2">محصول</div>
                      <OverlayTrigger
                        placement="top"
                        delay={{ show: 250, hide: 400 }}
                        overlay={renderTooltip}
                      >
                        <div>
                          <span>
                            <label className="adl-switch">
                              <input disabled type="checkbox" />
                              <span className="adl-slider round"></span>
                            </label>
                          </span>
                        </div>
                      </OverlayTrigger>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            {sitesPublisher.length == 0 &&
            siteNameSearchFilter == null &&
            categoryNameSearchFilter == null ? (
              <></>
            ) : (
              generateTagSitesPublisher()
            )}
          </div>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    categoryUser: state.main.categoryUser,
  };
};

export default connect(mapStateToProps, {})(ListPublisher);
